import React from 'react';

type CardRowProps = {
  children?: React.ReactNode;
  gap?: string;
  padding?: string;
  style?: React.CSSProperties;
};

const CardRow: React.FC<CardRowProps> = ({
  children,
  gap = 'auto',
  padding = '0',
  style = {},
}) => {
  const combinedStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap', // allows wrapping on smaller screens
    gap,
    padding,
    width: '100%', // ensures it fills the parent
    boxSizing: 'border-box',
    ...style,
  };

  return <div style={combinedStyles}>{children}</div>;
};

export default CardRow;
